<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/ForgotPassword'

    export default {
        components: {
            Grid,
        }
    }
</script>